import React, { Component } from 'react';
import { NavBar, Toast } from 'antd-mobile';
import { ROOT_PATH } from '../../config';
import axios from 'axios';
import { FARM_ORG, ORG_CODE, TOKEN } from '../../cache';
import qs from 'qs';
import Table from '../../components/Table';

class CostAnalysisDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns1: [
        {
          id: 'col1',
          title: '名称',
          width: 120,
          align: 'left',
        },
        {
          id: 'col2',
          title: '总额',
          align: 'right'
        },
        {
          id: 'col3',
          title: '单位',
          align: 'right'
        }
      ],
      columns2: [
        {
          id: 'col1',
          title: '名称',
          width: 110,
          align: 'left',
        },
        {
          id: 'col2',
          title: '总额',
          align: 'right'
        },
        {
          id: 'col3',
          title: '数量',
          align: 'right'
        },
        {
          id: 'col4',
          title: '单位',
          align: 'right'
        }
      ],
      gdCode: '0',
      data: []
    }
  }

  getData = (obj) => {
    Toast.loading('加载中...', 0);
    axios.post(
      `${ROOT_PATH}/api/forward/ifarm/2/costAnalySisListCommand2`,
      qs.stringify(
        {
          'dateStart': obj.startDate,
          'dateEnd': obj.endDate,
          'gdType': obj.gdType,
          'gdCode': obj.gdCode,
          'paraClickValue1': obj.gdType + '.' + obj.gdCode
        }
      ),
      {
        headers: {
          'x-http-appid': '1',
          'x-http-device': '0',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': TOKEN,
          'farmorg': FARM_ORG,
          'orgcode': ORG_CODE
        }
      }
    )
      .then(res => {
        Toast.hide();
        this.updateTable(res.data);
      })
      .catch(err => {
        return err;
      })
  }

  updateTable(data) {
    let firstObj = data[0];
    let code = firstObj.gdCode;

    let dataSource = [];

    if (code.startsWith('300')) {
      data.map(obj => {
        let newObj = {};
        newObj['col1'] = obj.descLoc;
        newObj['col2'] = (obj.val_1) !== undefined ? (obj.val_1) : '-'; 
        newObj['col3'] = (obj.val_2) !== undefined ? (obj.val_2) : '-';
        newObj['col4'] = (obj.val_3) !== undefined ? (obj.val_3) : '-';
        dataSource.push(newObj);
      });
    } else {
      data.map(obj => {
        let newObj = {};
        newObj['col1'] = obj.descLoc;
        newObj['col2'] = (obj.val_1) !== undefined ? (obj.val_1) : '-';
        newObj['col3'] = (obj.val_2) !== undefined ? (obj.val_2) : '-';
        dataSource.push(newObj);
      });
    }

    this.setState({
      gdCode: code,
      data: dataSource,
    });
  }

  componentDidMount() {
    this.getData(this.props.data);
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    }
  }

  render() {
    let currentColumus = this.state.gdCode.startsWith('300') ? this.state.columns2 : this.state.columns1;
    return (
      <div className="report-detail-bg">
        <div className="report-header">
          <NavBar mode="light">成本分析</NavBar>
        </div>
        <div className="report-content">
          <Table columns={currentColumus} data={this.state.data} />
        </div>
      </div>
    )
    
  }
}

export default CostAnalysisDetail;